const getRowMetaData = (rowData) => {
  if (!rowData || !rowData.attribute) {
    return { rowData: rowData };
  }

  switch (rowData.attribute.attributeType) {
    case 'INTEGER':
      return { options: { format: { decimals: 0 } }, rowData: rowData };

    case 'NUMERIC':
      return { options: { format: { decimals: 2 } }, rowData: rowData };

    default:
      return { rowData: rowData };
  }
};

export default getRowMetaData;
